import { ACCOUNT_TIERS } from 'types/billing';

export type BonusTier = typeof ACCOUNT_TIERS.free | typeof ACCOUNT_TIERS.paid;

export const TIER_DISCOUNT: Record<BonusTier, number> = {
  [ACCOUNT_TIERS.free]: 25,
  [ACCOUNT_TIERS.paid]: 50,
};

export const TIER_MONTHS: Record<BonusTier, number> = {
  [ACCOUNT_TIERS.free]: 2,
  [ACCOUNT_TIERS.paid]: 2,
};

export const isBonusTier = (t: string): t is BonusTier => t in TIER_DISCOUNT;
